import {
  AnimationComponent,
  Box,
  Grid2,
  LockIcon,
  Show,
  Tab,
  Tabs,
  Typography,
} from "components";
import DashboardLayout from "layouts/DashboardLayout";
import EquityCashSection from "Pages/PortfolioSummary/EquityCashSection";
import { lazy } from "react";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { AccountType } from "utils/common";

const HoldingPage = lazy(() => import("Pages/PortfolioSummary"));
const PortfolioPage = lazy(() => import("Pages/Portfolio/PortfolioList"));
const PortfolioGroupPage = lazy(
  () => import("Pages/PortfolioGrouping/PortfolioGroupList"),
);

const DashboardMenu = () => {
  const dispatch = useAppDispatch();

  const userInfo = useAppSelector((state) => state?.user?.userData);

  const userData = useAppSelector((state) => state?.user?.userData);
  const { tabValueDashboard } = useAppSelector((state) => state?.app?.tab);

  const tabs = [
    {
      label: "Summary",
      component: HoldingPage,
      showEquityCash: true,
      canAccess: true,
      accountType: [AccountType.RA_RIA, AccountType.RIA, AccountType.RA],
    },
    {
      label: "Portfolio",
      component: PortfolioPage,
      showEquityCash: true,
      canAccess: true,
      accountType: [AccountType.RA_RIA, AccountType.RIA, AccountType.RA],
    },
    {
      label: "Portfolio Group",
      component: PortfolioGroupPage,
      showEquityCash: false,
      canAccess: userData?.grantAccess,
      accountType: [AccountType.RA_RIA, AccountType.RIA],
    },
  ];

  return (
    <DashboardLayout title="Dashboard">
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Grid2 container>
              <Grid2 size={6}>
                <Tabs
                  sx={{
                    "& .MuiTabs-flexContainer": {
                      backgroundColor: "var(--white)",
                    },
                  }}
                  onChange={(e, val) => {
                    dispatch(
                      TAB({ tabKey: "tabValueDashboard", tabValue: val }),
                    );
                  }}
                  value={tabValueDashboard}
                >
                  {tabs
                    ?.filter((tab) =>
                      tab?.accountType?.includes(userInfo?.accountType),
                    )
                    ?.map((tab, index) => (
                      <Tab
                        disabled={!tab.canAccess}
                        key={index}
                        label={
                          <Box display={"flex"} gap={1}>
                            <Typography>{tab.label}</Typography>
                            {!tab.canAccess && (
                              <LockIcon width={16} height={16} />
                            )}
                          </Box>
                        }
                        disableRipple
                      />
                    ))}
                </Tabs>
              </Grid2>
              <Show.When isTrue={tabs[tabValueDashboard]?.showEquityCash}>
                <Grid2 size={6} textAlign="right">
                  <EquityCashSection />
                </Grid2>
              </Show.When>
            </Grid2>
          </Box>
        </Grid2>
        <Grid2 size={12}>
          {tabs.map((tab, index) => (
            <Show.When key={index} isTrue={tabValueDashboard === index}>
              <AnimationComponent>
                <tab.component />
              </AnimationComponent>
            </Show.When>
          ))}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default DashboardMenu;
